import { MutationTree } from 'vuex';
import { IndustryState, Industry } from './industry-types';

export const mutations: MutationTree<IndustryState> = {
  setIndustriesInState(state, payload: Industry) {
    state.error = false;
    state.industry = payload;
  },
  profileError(state) {
    state.error = true;
    state.industry = undefined;
  },
};
